<template>
  <v-container class="custom-container">
    <v-row dense>
      <v-col cols="12">
        <v-card
          class="pa-5 live-trade-details-card"
          elevation="0"
          :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'"
        >
          <v-row class="no-gutters align-center">
            <v-col cols="12" sm="6" md="3" lg="3">
              <v-text-field
                v-model="search"
                prepend-icon="mdi-magnify"
                label="Search here..."
                single-line
                solo
                hide-details
                class="mt-0"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="2" lg="2">
              <v-select
                solo
                :items="slots1"
                append-icon="mdi-chevron-down"
                label="All Group"
                class="custom-select mt-0"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="3" lg="3">
              <v-dialog
                ref="dialog"
                v-model="modal"
                :return-value.sync="date"
                width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dateRangeText"
                    prepend-icon="mdi-calendar"
                    append-icon="mdi-chevron-down"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    solo
                    class="custom-select mt-0"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="date"
                  class="custom-date-picker"
                  scrollable
                  range
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    :color="$vuetify.theme.dark ? '#ff567f' : '#ff567f'"
                    text
                    @click="modal = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    :color="$vuetify.theme.dark ? '#fff' : '#131c29'"
                    text
                    @click="$refs.dialog.save(date)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="4">
              <ul class="mt-0">
                <li>
                  <span class="">Total Account:</span>
                  <span>129</span>
                </li>

                <li>
                  <span class="">Total Equity:</span>
                  <span>12090</span>
                </li>
                <li>
                  <span class="text--green">Total Balance:</span>
                  <span>25436</span>
                </li>
              </ul>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="12">
              <v-card
                class="pa-0 rounded-0 elevation-0"
                :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'"
              >
                <v-sheet
                  class="transactionTable depositTabTable registerUserTable"
                  :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'"
                >
                  <v-data-table
                    :headers="headers"
                    :items="Transaction"
                    :items-per-page="5"
                  >
                    <template v-slot:item.nameLink="{ item }">
                      <router-link
                        class="text-capitalize text--ash"
                        :to="item.nameLinkName"
                      >
                        {{ item.nameLink }}
                      </router-link>
                    </template>
                    <template v-slot:item.accNo="{ item }">
                      <router-link
                        class="text-capitalize text--ash"
                        :to="item.accNameLink"
                      >
                        {{ item.accName }}
                      </router-link>
                    </template>
                    <template v-slot:item.status="{ item }">
                      <div class="d-flex">
                        <v-icon small :class="verifyIcon(item.status)"></v-icon>
                        {{ item.status }}
                      </div>
                    </template>
                  </v-data-table>
                </v-sheet>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      search: "",
      modal: false,
      dialog: false,
      date: ["2022-01-01", "2023-01-01"],
      slots1: ["7100001492(MICRO)", "7100006392(MICRO)", "7102006392(MICRO)"],
      headers: [
        { text: "Date and Time", align: "start", value: "dateAndTime" },
        { text: "Name", value: "nameLink" },
        { text: "Email", value: "email" },
        { text: "Acc.No.", value: "accNo" },
        { text: "Password", value: "password" },
        { text: "Investor Pass.", value: "invPassword" },
        { text: "Leverage", value: "leverage" },
        { text: "Equity", value: "equity" },
        { text: "Balance", value: "balance" },
        { text: "Status", value: "status" },
      ],

      Transaction: [
        {
          dateAndTime: "25.08.20-08:32 am",
          nameLink: "Abu Bokor",
          nameLinkName: "/abu-bokor",
          email: "abuBokor@gmail.com",
          accName: "5004",
          accNameLink: "/5004",
          password: "pvKVYCEq",
          invPassword: "pvKVYCEq",
          leverage: "10",
          equity: "2.1",
          balance: "$100",
          status: "Enable",
        },
        {
          dateAndTime: "28.05.10-08:12 pm",
          nameLink: "Osman",
          nameLinkName: "/osman",
          email: "osman@gmail.com",
          accName: "992",
          accNameLink: "/992",
          password: "Adjeuwi",
          invPassword: "Adjeuwi",
          leverage: "17",
          equity: "1.1",
          balance: "$80",
          status: "Disable",
        },
        {
          dateAndTime: "25.08.20-08:32 am",
          nameLink: "Abu Bokor",
          nameLinkName: "/abu-bokor",
          email: "abuBokor@gmail.com",
          accName: "5004",
          accNameLink: "/5004",
          password: "pvKVYCEq",
          invPassword: "pvKVYCEq",
          leverage: "10",
          equity: "2.1",
          balance: "$100",
          status: "Enable",
        },
        {
          dateAndTime: "28.05.10-08:12 pm",
          nameLink: "Osman",
          nameLinkName: "/osman",
          email: "osman@gmail.com",
          accName: "992",
          accNameLink: "/992",
          password: "Adjeuwi",
          invPassword: "Adjeuwi",
          leverage: "17",
          equity: "1.1",
          balance: "$80",
          status: "Disable",
        },
        {
          dateAndTime: "25.08.20-08:32 am",
          nameLink: "Abu Bokor",
          nameLinkName: "/abu-bokor",
          email: "abuBokor@gmail.com",
          accName: "5004",
          accNameLink: "/5004",
          password: "pvKVYCEq",
          invPassword: "pvKVYCEq",
          leverage: "10",
          equity: "2.1",
          balance: "$100",
          status: "Enable",
        },
        {
          dateAndTime: "28.05.10-08:12 pm",
          nameLink: "Osman",
          nameLinkName: "/osman",
          email: "osman@gmail.com",
          accName: "992",
          accNameLink: "/992",
          password: "Adjeuwi",
          invPassword: "Adjeuwi",
          leverage: "17",
          equity: "1.1",
          balance: "$80",
          status: "Disable",
        },
        {
          dateAndTime: "25.08.20-08:32 am",
          nameLink: "Abu Bokor",
          nameLinkName: "/abu-bokor",
          email: "abuBokor@gmail.com",
          accName: "5004",
          accNameLink: "/5004",
          password: "pvKVYCEq",
          invPassword: "pvKVYCEq",
          leverage: "10",
          equity: "2.1",
          balance: "$100",
          status: "Enable",
        },
        {
          dateAndTime: "28.05.10-08:12 pm",
          nameLink: "Osman",
          nameLinkName: "/osman",
          email: "osman@gmail.com",
          accName: "992",
          accNameLink: "/992",
          password: "Adjeuwi",
          invPassword: "Adjeuwi",
          leverage: "17",
          equity: "1.1",
          balance: "$80",
          status: "Disable",
        },
      ],
    };
  },
  methods: {
    verifyIcon(status) {
      if (status === "Enable") return "mdi mdi-check text--green mr-1";
      else return "mdi mdi-window-close red--text mr-1";
    },
  },
  computed: {
    dateRangeText() {
      return this.date.join(" ~ ");
    },
  },
};
</script>
